import React, { useEffect } from "react";

function AdComponentSquare() {
  useEffect(() => {
    let googletag = window.googletag || { cmd: [] };
    googletag.cmd.push(function () {
      googletag.defineSlot('/23108002729/1-play.pasoogames.com/300x250', ['fluid', [300, 250]], 'div-gpt-ad-1716386992193-0').addService(googletag.pubads());
      googletag.enableServices();
    });

    googletag.cmd.push(function () { googletag.display('div-gpt-ad-1716386992193-0'); });

    window.googletag = googletag;
  }, []);

  return (
    // <ins
    //   class="adsbygoogle"
    //   style={{ display: "block", width: "300px", height: "250px" }}
    //   data-ad-client="ca-pub-9423830303908191"
    //   data-ad-slot="4278598613"
    // ></ins>
    <div id='div-gpt-ad-1716386992193-0' style={{ min_width: "300px", min_height: "250px" }}>
    </div>
  );
}

export default AdComponentSquare;
